module.exports = __webpack_public_path__ + "img/customer-service@2x.08d9fe36.png";